module.exports = __webpack_public_path__ + "assets/f93f26f6489f58b70e8a1da1db3d7cf6.png";